<template>
	<v-container>
		<v-layout column>
			<v-card>
				<v-card-title>Appearence</v-card-title>
				<v-card-text>
					<v-checkbox v-model="isDarkLocal" label="Dark theme"></v-checkbox>
				</v-card-text>
			</v-card>
		</v-layout>
	</v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
	components: {},
	data() {
		return {};
	},
	computed: {
		...mapGetters(["userToken", "isDark"]),
		isDarkLocal: {
			get() {
				return this.isDark; // comes from store
			},
			set(val) {
				this.setDarkMode(val);
			}
		}
	},
	methods: {
		...mapActions(["setDarkMode"])
	},
	mounted() {}
};
</script>